import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userDetail: [],
};

export const userDetailsSlice = createSlice({
  name: "UserDetails",
  initialState,
  reducers: {
    addUserDetails: (state, action) => {
      state.userDetail = action.payload;
    },
  },
});
export const { addUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
